const { getEnumManageConfig } = require('@/views/system/enum-manage/config');
const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = () => {
  return {
    type: {
      label: '渠道',
      type: 'select',
      options: getEnumManageConfig().channel_interface_options,
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    tag_name: {
      label: '枚举标签名称',
      type: 'input',
      value: '',
    },
    enum_name: {
      label: '枚举值名称',
      type: 'input',
      value: '',
    },
  };
};

